// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../store-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".camera-icon[data-v-6d60c38a]{width:80px;border:1px solid #c6c6c6;border-radius:50%;background:#f6f6f6;color:#2c5bc5;height:80px;cursor:pointer}.camera-icon .fa-layers[data-v-6d60c38a]{width:100%;height:100%}.camera-icon .fa-plus[data-v-6d60c38a]{left:-40px;top:-30px}", ""]);
// Exports
module.exports = exports;
